import { useEffect, useState } from 'react';
import { arrayToSimpleObj } from '@op/utils';
import { UseGetCalendarData, CalendarData } from '../type';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getWeeklyAccountCalendar, modifyWeeklyAccountCalendar } from '@op/services';

export function useGetCalendarData({ calendarTime }: UseGetCalendarData) {
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
  });
  // 日历全部数据
  const [calendarData, setCalendarData] = useState<{ [key: string]: string }>(
    {},
  );

  useEffect(() => {
    if (!calendarTime) return;

    wrapperCancelRequest(getWeeklyAccountCalendar, {
      ...calendarTime,
    })
      .then((data: CalendarData[]) => {
        setCalendarData(arrayToSimpleObj(data, 'content', 'date'));
      })
      .catch(e => console.log(e));
  }, [calendarTime]);

  function modifyCalendar(params: any) {
    return modifyWeeklyAccountCalendar({ data: params })
      .then(() => true)
      .catch(e => false);
  }

  return {
    calendarData,
    setCalendarData,
    modifyCalendar,
    loading
  };
}
